/**
 * carousel.js
 * 
 * Initialise all carousels on the page with the glide carousel library.
 */

function init_carousels($, window, document) {


    const carousels = $('.tms-carousel');

    if (carousels.length > 0) {

      $.each(carousels, function() {

        
        const style = $(this).data('carousel-style');


        const perView = (style === 'styled') ? 2 : 3;
        const perSwipe = (style === 'styled') ? 2 : '|';
        
        const has_dots = $(this).hasClass('show_dots');
        const has_arrows = $(this).hasClass('show_arrows');

        const arrowNext = (has_dots) ? '<' : '|<';
        const arrowPrev = (has_dots) ? '>' : '|>';

        let breakpoints = {
          640: {
              perView: 1,
              gap: 20,
              peek: {
                  after: 80,
                  before: 0
              }
          },
          992: {
              perView: 2,
              peek: {
                  after: 0,
                  before: 0
              }
          }
        };

        if (style === 'styled') {
          breakpoints = {
            767: {
              perView: 1,
              gap: 20,
              peek: {
                  after: (has_arrows) ? 0 : 20,
                  before: 0
              }
            },
            991: {
                perView: 1,
                gap: 20,
                peek: {
                    after: (has_arrows) ? 60 : 80,
                    before: 0
                }
            }
          };
        }

        // For some reason the > converts the following quote to a smart quote...
        $(this).find('.glide__arrow--left').attr('data-glide-dir', arrowNext);
        $(this).find('.glide__arrow--right').attr('data-glide-dir', arrowPrev);
        
        const config = {
          type: "slider",
          gap: 24,
          rewind: !1,
          animationDuration: 400,
          // animationTimingFunc: "".concat("cubic-bezier(0.35, 0.00, 0.36, 1.00)", " ").concat(0, "ms"),
          perView: perView,
          perTouch: perSwipe,
          breakpoints: breakpoints
        }



      
        const glide = new Glide( this, config);
        glide.mount()
      });
      
    } 
  
}



document.addEventListener('DOMContentLoaded', () => {
  init_carousels(jQuery, window, document);
});